export const BREAKPOINTS_SWITCH = 'BREAKPOINTS_SWITCH';

export function switchBreakpoints(payload) {
    return {
        type: BREAKPOINTS_SWITCH,
        payload
    };
}



// WEBPACK FOOTER //
// ./src/js/Breakpoints/breakpoints.actions.js